import * as React from 'react'
import {useTranslation} from "gatsby-plugin-react-i18next";
import {generateUrl} from '../utils/generateUrl';

import {Search} from './Search';
import {graphql, useStaticQuery, Link} from "gatsby";

export const Footer = ({activeDocMeta, themes, data}) => {
	const {t} = useTranslation();

	let translations = {};
	if (activeDocMeta.url) {
		translations[activeDocMeta.lang] = activeDocMeta.url;
	}

	if (activeDocMeta.alternateLanguages) {
		activeDocMeta.alternateLanguages.forEach((value) => {
			if (value.document) {
				translations[value.lang] = value.document.url;
			}
		});
	}


	const queryData = useStaticQuery(graphql`
    query SiteFooterQuery {
	  localSearchPages {
        index
        store
	  }
	  prismicSearchResults(lang: {eq: "nl-be"}) {
		data {
		  suggestions {
			search_suggestion
		  }
		}
	  }  
	  allPrismicEditorial(
		filter: {data: {show_in_footer: {eq: true}}, lang: {eq: "nl-be"}}
		sort: {fields: data___weight, order: ASC}
	  ) {
		nodes {
		  id
		  url
		  data {
			title {
			  text
			}
		  }
		}
	  }	      
    }
  `);

	const index = queryData.localSearchPages.index
	const store = queryData.localSearchPages.store

	return (
		<footer className="c-footer" role="contentinfo">
			<Search
				index={index}
				store={store}
				suggestions={queryData.prismicSearchResults.data.suggestions}
			/>

			<div className="o-wrapper">
				<nav id="footer-breadcrumbs" aria-label="Je bent hier">
					<ul className="c-footer__breadcrumb">
						<li>
							<a href="https://www.vdab.be" className="c-footer__breadcrumb__logo">
								<img src="/vdab-logo-white.svg" alt="VDAB" />
							</a>
						</li>

						<li className="c-footer__breadcrumb__item" aria-current="page">
							<Link className='c-footer__link' to={generateUrl(activeDocMeta.lang, '')}>{t('siteName')}</Link>
						</li>
					</ul>
				</nav>

				<div className="mt0">
					<section className="c-footer__link-container" aria-label="Handige links">
						<ul className="c-footer__link-container-column u-reset-list o-3-col">
							{themes.nodes.map((value) => {
								return <li key={value.id}><a href={value.url} className="c-footer__link" key={value.id}>{value.data.title.text}</a></li>
							})}
						</ul>
						{(queryData.allPrismicEditorial?.nodes && queryData.allPrismicEditorial.nodes.length) > 0 &&
							<ul className="c-footer__link-container-column u-reset-list o-3-col">
								{queryData.allPrismicEditorial.nodes.map((value) => {
									return <li key={value.id}><a href={value.url} className="c-footer__link icon-info" key={value.id}>{value.data.title.text}</a></li>
								})}
							</ul>
						}
						<div className="c-footer__button-group">
							<a href="https://www.vdab.be/" className="c-footer__button-group__button">{t('Naar site werkzoekenden')}</a>
							<a href="https://www.vdab.be/werkgevers" className="c-footer__button-group__button">{t('Naar site werkgevers')}</a>
							<a href="https://www.vdab.be/partners" className="c-footer__button-group__button">{t('Naar site partners')}</a>
						</div>
					</section>
				</div>
			</div>
			<div className="c-footer__flanders">
				<div className="c-footer__flanders__container o-wrapper">
					<a href="https://www.vlaanderen.be/" className="c-footer__flanders__backslash-before -logo-backslash c-footer__flanders__link -logo-link">
						{t('Dit is een officiële website van de Vlaamse overheid')}
					</a>
					<div className="c-footer__flanders__container -right-side">
						<a className="c-footer__flanders__backslash-before c-footer__flanders__link" href={generateUrl(activeDocMeta.lang, 'disclaimer')}>{t('Disclaimer')}</a>
						<a className="c-footer__flanders__backslash-before c-footer__flanders__link" href={generateUrl(activeDocMeta.lang, 'cookies')}>{t('Cookie Policy')}</a>
					</div>
				</div>
			</div>
		</footer>
	)
}
